import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../../constants/Colors";
import { allIcons } from "../../../assets";
import moment from "moment";

const ServiceCard = ({
  data,
  showActions,
  canSelectService,
  event,
  handleSelectedService,
}) => {
  const { serviceData, teamMemberData, startTime, endTime } = data;
  console.log(serviceData, "datadatadatadatadata");

  return (
    <Stack
      p={1.5}
      my={1}
      position={"relative"}
      borderRadius={"5px 0px 0px 5px"}
      border={"1px solid #8692A6"}
      sx={{
        cursor: "pointer",
        transition: "background-color 0.3s ease-in-out",
        "&:hover": {
          backgroundColor: "#FDEEE6",
        },
        "&:hover .action-icons": {
          opacity: showActions ? 1 : 0,
          visibility: showActions ? "visible" : "hidden",
        },
      }}
      onClick={() => {
        if (canSelectService) {
          handleSelectedService(data);
        }
      }}
    >
      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          my: 0,
          borderWidth: 4,
          borderRadius: "12px",
          borderColor: "#FDEEE6",
        }}
      />
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="body1" color={appcolors.black} fontWeight={500}>
          {serviceData?.serviceName}
        </Typography>
        <Typography variant="body1" color={appcolors.black} fontWeight={500}>
          {serviceData?.price} SAR
        </Typography>
      </Stack>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="body2">
          {moment(startTime).format("hh : mm A")} -{" "}
          {moment(endTime).format("hh : mm A")}, {serviceData?.duration} min{" "}
          {teamMemberData?.firstname} {teamMemberData?.lastname}
        </Typography>
        {showActions && (
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={0.5}
            className="action-icons"
            sx={{
              opacity: 0,
              visibility: "hidden",
              transition:
                "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
            }}
          >
            <img src={allIcons.editIcon} width={16} />
            <img src={allIcons.deleteIcon} width={16} />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default ServiceCard;
